import React from 'react';
import {
  pluralize,
} from '@populateui/utils';
import {
  clsx,
} from 'clsx';
import {
  Button,
} from 'pages/Dashboard/components/Button';
import {
  billingEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

type Props = {
  selectedRows: number[];
};

export default function ClaimSelectionBanner({ selectedRows }: Props) {
  return (
    <div className={clsx(
      'sticky text-xs top-0 z-10 flex items-center justify-between rounded-lg bg-blue-50 px-2 py-2 shadow mx-4',
      'transition-all duration-300',
      {
        'h-0 opacity-0': selectedRows.length === 0,
        'h-14 opacity-100 py-2 mb-4': selectedRows.length > 0,
      },
    )}
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 h-8 w-8 justify-center bg-blue-500 rounded-md">
          <CheckCircleOutlinedIcon className="text-white w-4 h-4" />
        </div>
        <div className="flex flex-col text-xs">
          <span className="font-semibold text-gray-800">
            {pluralize('claim', selectedRows.length)}
            {' '}
            selected
          </span>
          <span className="text-gray-500 font-medium">Apply updates to selected claims</span>
        </div>
      </div>
      <div className="flex gap-2 items-center">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            billingEventChannel.emit('onBulkClaimStatusDialogOpen', {
              claimIds: selectedRows,
            });
          }}
        >
          Update Status
        </Button>
      </div>
    </div>
  );
}
